// Compact theme toggle button — cycles dark → light → system.
// Used in the navbar; settings page has the full picker.
import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "@/hooks/useTheme";
import { cn } from "@/lib/utils";

const ICONS = {
  light: Sun,
  dark: Moon,
  system: Monitor,
} as const;

const NEXT = {
  dark: "light",
  light: "system",
  system: "dark",
} as const;

const LABEL = {
  dark: "Dark theme — click for light",
  light: "Light theme — click for system",
  system: "System theme — click for dark",
} as const;

const ThemeToggle = ({ className }: { className?: string }) => {
  const { theme, setTheme } = useTheme();
  const Icon = ICONS[theme];
  return (
    <button
      type="button"
      onClick={() => setTheme(NEXT[theme])}
      aria-label={LABEL[theme]}
      title={LABEL[theme]}
      className={cn(
        "flex items-center justify-center w-9 h-9 rounded-md text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors",
        className,
      )}
    >
      <Icon className="w-4 h-4" />
    </button>
  );
};

export default ThemeToggle;
